import fonts from "../../editor/constants/fonts";

const Graph = new class Graph {

    constructor() {
        this.isInit = false;
        this.nodes = [];
        this.links = [];
        this.path = null;
        this.enabled = true;
        this.success = false;
        this.viewerMode = false;

        this.resultNodes = [];
        this.resultLinks = [];
        this.touchMoveNode = {};

        this.lastKeyDown = -1;
        this.domElement = null;
        this.radius = 30;
        this.circleColor = "#51bae8";
        this.circleTextColor = "#fff";
        this.lineColor = "#000";
        this.lineWidth = 10;
        this.selectedLineWidth = this.lineWidth * 1.25;

        window.graphService = this;
        this.resizeHandler = this.resizeHandler.bind(this);
        this.keydownHandler = this.keydownHandler.bind(this);
    }

    get width() {
        return this.domElement.offsetWidth;
    }

    get height() {
        return this.domElement.offsetHeight;
    }

    resizeHandler() {
        setTimeout(() => {
            this.resize()
        }, Q3.editMode ? 1000 : 0)
    }

    keydownHandler() {
        if (!document.activeElement.classList.contains("text-cnt")) return;
        if (e.key === "Enter") {
            let ind = this.selectedNodes.indexOf(document.activeElement.id);
            if (ind === -1) {
                this.selectedNodes.push(document.activeElement.id);
                document.activeElement.classList.add("selected");
            } else {
                this.selectedNodes.splice(ind, 1);
                document.activeElement.classList.remove("selected");
            }
            if (this.selectedNodes.length === 2) {

                let source = this.getNode(this.selectedNodes[0]);
                let target = this.getNode(this.selectedNodes[1]);

                let link;
                link = this.links.filter((l) => {
                    return (l.source === source && l.target === target || l.source === target && l.target === source);
                })[0];

                if (!link) {
                    link = { source: source, target: target };
                    this.links.push(link);
                }

                $(".connect-quiz .text-cnt.selected").removeClass("selected");
                this.selectedNodes = [];
                this.restart();
            }
        } else if (e.key === "Delete") {
            this.links = this.links.filter((l) => l.source.id !== Number(document.activeElement.id) && l.target.id !== Number(document.activeElement.id))
            this.restart();
        }
    }

    init(domElement, quizData, resultData, viewerMode, onCreateLink) {
        if (!domElement) return null;
        return awaitLib().then(() => {
            if (this.isInit) return null;
            let connections = quizData.connections;
            if (quizData.isSubmitted) {
                connections = quizData.userAnswer;
                this.enabled = false;
            }
            this.onCreateLink = onCreateLink;
            this.domElement = domElement;
            if (this.radius > this.width / 10) {
                this.radius = this.width / 10;
            }
            this.circleColor = quizData.circleColor || "#51bae8";
            this.circleTextColor = quizData.circleTextColor || "#fff";
            this.lineColor = quizData.lineColor || "#000";
            this.isInit = true;
            Q3.Events.fire("graphupdated");
            this.halfscreen = quizData.layout === "halfscreen";
            this.squareNodes = quizData.squareNodes || false;
            this.selectedNodes = [];
            window.addEventListener("resize", this.resizeHandler);
            window.addEventListener('keydown', this.keydownHandler);
            // set up SVG for D3

            $(domElement).empty();
            this.svg = d3.select(domElement)
                .append('svg')
                // .attr("preserveAspectRatio", "xMinYMin meet")
                // .attr("viewBox", 0 + " -" + 0 + " " + this.width + " " + (this.height > 0 ? this.height : this.width))
                .classed("svg-content", true)
                .attr('width', "100%")
                .attr('height', "100%");
            this.removeLinkBtn = $('<div class="quiz-msg-btn remove-connection hidden">remove connection</div>');
            this.removeLinkBtn.click(() => {
                this.deleteLinkByKey(this.selected_link);
                this.removeLinkBtn.addClass("hidden");
            });
            $(domElement).append(this.removeLinkBtn);
            // set up initial nodes and links
            //  - nodes are known by 'id', not by index in array.
            //  - reflexive edges are indicated on the node (as a bold black circle).
            //  - links are always source < target; edge directions are set by 'left' and 'right'.
            this.maxRadius = this.radius;
            quizData.nodes.forEach((d) => {
                let nodeRadius = d.radius;
                if (nodeRadius > this.maxRadius) {
                    this.maxRadius = nodeRadius
                }
            });

            this.data = { nodes: quizData.nodes, connections: connections };
            d3.selectAll(this.data.nodes)
                .each((d, i) => {
                    this.nodes.push(this.createNode(this.data.nodes[i]));
                });
            d3.selectAll(this.data.connections)
                .each((d, i) => {
                    let source = this.getNode(this.data.connections[i].source),
                        target = this.getNode(this.data.connections[i].target);
                    if (source.id && target.id) {
                        this.links.push(this.createLinks(source, target));
                    }

                });

            this.lastNodeId = this.nodes.length;

            // init D3 force layout
            let linkDistance = 50;
            // if (linkDistance > this.width*0.5) {
            //   linkDistance = this.width*0.5;
            // }
            this.force = d3.layout.force()
                .nodes(this.nodes)
                .links(this.links)
                .size([this.width, this.height])
                .linkDistance((nodes) => { return nodes.source.radius + nodes.target.radius + (this.halfscreen ? 50 : 75) })
                .charge(this.maxRadius * -10)
                .gravity(0.1)
                .on('tick', this.tick.bind(this));

            this.resize();
            d3.select(window).on("resize", this.resize.bind(this));


            // define arrow markers for graph links
            this.svg.append('svg:defs').append('svg:marker')
                .style('stroke-width', this.lineWidth)
                // .attr('id', 'end-arrow')
                .attr('viewBox', '0 -5 10 10')
                .attr('refX', 6)
                .attr('markerWidth', 3)
                .attr('markerHeight', 3)
                .attr('orient', 'auto')
                .append('svg:path')
                .attr('d', 'M0,-5L10,0L0,5')
                .attr('stroke', this.lineColor)
                .attr('fill', this.lineColor);

            this.svg.append('svg:defs').append('svg:marker')
                .style('stroke-width', this.lineWidth)
                // .attr('id', 'start-arrow')
                .attr('viewBox', '0 -5 10 10')
                .attr('refX', 4)
                .attr('markerWidth', 3)
                .attr('markerHeight', 3)
                .attr('orient', 'auto')
                .append('svg:path')
                .attr('d', 'M10,-5L0,0L10,5')
                .attr('stroke', this.lineColor)
                .attr('fill', this.lineColor);

            // line displayed when dragging new nodes
            this.drag_line = this.svg.append('svg:path')
                .style('stroke-width', this.lineWidth)
                .attr('class', 'link dragline hidden')
                .attr('stroke', this.lineColor)
                .attr('d', 'M0,0L0,0');

            // handles to link and node element groups
            this.path = this.svg.append('svg:g').selectAll('path');
            this.circle = this.svg.append('svg:g').selectAll('g');


            // mouse event vars
            this.selected_node = null;
            this.selected_link = null;
            this.mousedown_link = null;
            this.mousedown_node = null;
            this.mouseup_node = null;

            // app starts here
            this.svg.on('mousemove', this.mousemove.bind(this))
                .on('mouseup', this.mouseup.bind(this));
            this.svg.on('touchmove', this.mousemove.bind(this))
                .on('touchend', this.mouseup.bind(this));
            d3.select(window)
                .on('keydown', this.keydown.bind(this))
                .on('keyup', this.keyup.bind(this));
            this.restart();

            if (viewerMode) {
                this.viewerMode = true;
            }
            if (resultData) {
                this.setResultData(resultData);
            }
            if (quizData.isSubmitted) {
                this.getScore();
            }
        });
    }

    resize(gravity) {
        if (!this.domElement) return;
        this.svg.attr("width", this.width).attr("height", this.height);
        let fontSize = Math.min(24, Math.max(10, parseFloat($("html").css("font-size")))) * 1.2 * (this.halfscreen ? 0.85 : 1);
        $(this.svg[0]).css("font-size", fontSize + "px");
        this.maxRadius = 0;
        this.nodes.forEach((d) => {
            d.radius = this.calcRadius(d, fontSize);
            $("#circle" + d.id)
                .attr('r', d.radius*(this.squareNodes ? 1.1 : 1))
                .next()
                .attr('x', d.radius * -1)
                .attr('y', d.radius * -1)
                .attr('width', d.radius * 2)
                .attr('height', d.radius * 2);
            if (d.radius > this.maxRadius) {
                this.maxRadius = d.radius;
            }
        });
        let g = 0.1;
        this.force
            .size([this.width, this.height])
            .linkDistance((nodes) => { return nodes.source.radius + nodes.target.radius + (this.halfscreen ? 50 : 75) })
            .charge(this.maxRadius * -10)
            .gravity(gravity || g)
            .resume();
        this.path && this.restart();
    }


    calcRadius(d, fontSize = 12) {
        if (d.autoRadius === false && d.r) {
            return fontSize*d.r/2;
        }
        let longestWord = d.name.split(/[ \-]/).reduce(function (a, b) { return a.length > b.length ? a : b; });
        let temp = document.createElement("div");
        temp.innerHTML = longestWord;
        temp.style.position = "absolute";
        temp.style.opacity = 0;
        temp.style.fontSize = fontSize + "px";
        document.body.appendChild(temp);
        let minDiameter = Math.max(temp.offsetWidth, 50);
        temp.innerHTML = d.name;
        temp.style.width = minDiameter + "px";
        temp.style.height = minDiameter + "px";
        while (temp.offsetHeight < temp.scrollHeight || temp.offsetWidth < temp.scrollWidth) {
            let w = temp.offsetWidth;
            temp.style.width = w + 1 + "px";
            temp.style.height = w + 1 + "px";
        }
        let radius = temp.offsetWidth/2;
        temp.remove();
        return radius*1.4;
    }

    setResultData(data) {
        // let nodes = [];
        let links = [];

        // d3.selectAll(data.nodes)
        //   .each(function (d, i) {
        //     nodes.push(this.createNode(data.nodes[i]));
        //   });
        d3.selectAll(data.connections)
            .each((d, i) => {
                let source = this.getNode(data.connections[i].source, this.nodes),
                    target = this.getNode(data.connections[i].target, this.nodes);
                if (source.id && target.id) {
                    links.push(this.createLinks(source, target));
                }
            });
        // this.resultNodes = nodes;
        this.resultLinks = links;
    }

    tick() {
        if (!this.isInit) return
        // draw directed edges with proper padding from node centers
        this.circle.attr('transform', (d) => {
            d.x = this.calcX(d.x, d.radius);
            d.y = this.calcY(d.y, d.radius);
            return 'translate(' + d.x + ',' + d.y + ')';
        });

        this.path.attr('d', (d) => {
            return 'M' + d.source.x + ',' + d.source.y + 'L' + d.target.x + ',' + d.target.y;
        });
    }

    calcX(x, radius) {
        let width = this.width;
        return Math.max(radius, Math.min(width - radius, x))
    }

    calcY(y, radius) {
        let height = this.height;
        return Math.max(radius, Math.min(height - radius, y))
    }
    mousedown() {
        // prevent I-bar on drag
        //d3.event.preventDefault();

        // because :active only works in WebKit?
        this.svg.classed('active', true);

        if (d3.event.ctrlKey || d3.event.metaKey || this.mousedown_node || this.mousedown_link) return;

        // insert new node at point
        let point = d3.mouse(d3.event.currentTarget),
            tempId = ++this.lastNodeId,
            node = { id: tempId, reflexive: false, name: "VidaSystems" + tempId };
        node.x = point[0];
        node.y = point[1];
        this.nodes.push(node);

        this.restart();
    }

    mousemove() {
        if (!this.mousedown_node) return;
        let x;
        let y;
        let event = d3.event.type === "touchmove" ? "touches" : "mouse";
        if (d3.event.type === "touchmove") {
            x = d3[event](d3.event.currentTarget)[0][0];
            y = d3[event](d3.event.currentTarget)[0][1];
            let p = d3.touches(d3.event.currentTarget)[0];

            let circles = this.circle.selectAll('circle');
            let touchMoveNode = null;
            circles.each((d) => {
                let x = d.x - p[0],
                    y = d.y - p[1],
                    l = Math.sqrt(x * x + y * y),
                    r = d.radius;
                if (l < r) {
                    touchMoveNode = d;
                }
            });
            this.touchMoveNode = touchMoveNode;
        } else {
            x = d3[event](d3.event.currentTarget)[0];
            y = d3[event](d3.event.currentTarget)[1];
        }

        // update drag line
        let d = this.mousedown_node;
        let attr = 'M' + this.calcX(d.x, d.radius) + ',' + this.calcY(d.y, d.radius) + 'L' + x + ',' + y
        this.drag_line.attr('d', attr);

        this.restart();
    }

    mouseup() {
        if (this.mousedown_node) {
            // hide drag line
            this.drag_line
                .classed('hidden', true)
                .style('marker-end', '');
        }
        if(d3.event.target.tagName=='svg'){
            this.selected_node = null
            this.setActiveNode(null,false);
        }

        // because :active only works in WebKit?
        this.svg.classed('active', false);

        // clear mouse event vars
        this.resetMouseVars();
    }

    spliceLinksForNode(node) {
        let toSplice = this.links.filter((l) => {
            return (l.source === node || l.target === node);
        });
        toSplice.map((l) => {
            this.links.splice(this.links.indexOf(l), 1);
        });
    }

    keydown() {

        if (this.lastKeyDown !== -1) return;
        this.lastKeyDown = d3.event.keyCode;

        // ctrl
        if (d3.event.keyCode === 17) {
            this.circle.call(this.force.drag);
            this.svg.classed('ctrl', true);
        }

        if (!this.selected_node && !this.selected_link) return;
        switch (d3.event.keyCode) {
            case 8: // backspace
            case 46: // delete
                if (this.selected_node && !this.viewerMode) {
                    let focused = document.activeElement;
                    if (focused) {
                        let focusedTag = focused.tagName.toLowerCase();
                        if (focusedTag === 'input' || focusedTag === 'textarea') return;
                    }
                    this.deleteNodeByKey(this.selected_node);

                } else if (this.selected_link) {
                    this.deleteLinkByKey(this.selected_link);
                }

                break;
            case 66: // B
                if (this.selected_link) {
                    // set link direction to both left and right
                    this.selected_link.left = true;
                    this.selected_link.right = true;
                }
                this.restart();
                break;
            case 76: // L
                if (this.selected_link) {
                    // set link direction to left only
                    this.selected_link.left = true;
                    this.selected_link.right = false;
                }
                this.restart();
                break;
            case 82: // R
                if (this.selected_node) {
                    // toggle node reflexivity
                    this.selected_node.reflexive = !this.selected_node.reflexive;
                } else if (this.selected_link) {
                    // set link direction to right only
                    this.selected_link.left = false;
                    this.selected_link.right = true;
                }
                this.restart();
                break;
        }
    }

    keyup() {
        this.lastKeyDown = -1;

        // ctrl
        if (d3.event.keyCode === 17) {
            this.circle
                .on('mousedown.drag', null)
                .on('touchstart.drag', null);
            this.svg.classed('ctrl', false);
        }
    }

    updateSlideQuizLinks() {
        Q3.data.slides[Q3.SlideManager.activeSlide].slideQuiz.connections = this.links.map((link) => {
            return { source: link.source.id, target: link.target.id };
        });
    }

    restart = () => {
        // path (link) group
        this.path = this.path.data(this.links);

        // update existing links
        this.path.classed('selected', (d) => {
            return d === this.selected_link;
        })
            .style('stroke-width', (d) => {
                return d === this.selected_link ? this.selectedLineWidth : this.lineWidth;
            })

            // .style('marker-start', (d) => {
            //     return d.left ? 'url(#start-arrow)' : '';
            // })
            // .style('marker-end', (d) => {
            //     return d.right ? 'url(#end-arrow)' : '';
            // })
            .style('stroke', (d) => {
                if (d.type === "correct") {
                    return 'green'
                } else if (d.type === "wrong") {
                    return 'red';
                } else if (d.type === "result") {
                    return '#ffffff';
                }
            });
        if (!this.enabled) {
            let count = 0;
            let test = setInterval(function () {
                count++;
                if (count !== 60 && this.path) {
                    this.path.transition().duration(100).delay(100)
                        .style("display", (d) => {
                            if (this.path.style("display") == "block") {
                                if (d.type == "wrong") {
                                    return "none";
                                }
                            } else {
                                return "block";
                            }
                        });
                } else {
                    clearInterval(test);
                    return;
                }
            }, 1000);
        }


        // add new links
        this.path.enter().append('svg:path')
            .attr('class', 'link')
            .attr('stroke', this.lineColor)
            .style('stroke-width', this.lineWidth)
            //.classed('selected', function(d) { return d === this.selected_link; })
            // .style('marker-start', (d) => {
            //     return d.left ? 'url(#start-arrow)' : '';
            // })
            // .style('marker-end', (d) => {
            //     return d.right ? 'url(#end-arrow)' : '';
            // })
            .on('mousedown', (d) => {
                if (d3.event.ctrlKey) return;
                if (!this.enabled) return;

                // select link
                this.mousedown_link = d;
                this.deleteLinkByKey(d);
                // if (this.mousedown_link === this.selected_link) {
                //   this.selected_link = null;
                //   this.deleteLinkByKey(this.mousedown_link);
                //   this.removeLinkBtn.addClass("hidden");
                // } else {
                //   this.selected_link = this.mousedown_link;
                //   this.removeLinkBtn.removeClass("hidden");
                // }
                this.selected_node = null;
                this.restart();
            });

        // remove old links
        this.path.exit().remove();


        // circle (node) group
        // NB: the function arg is crucial here! nodes are known by id, not by index!
        this.circle = this.circle.data(this.nodes, (d) => {
            return d.id;
        });

        // update existing nodes (reflexive & selected visual states)
        this.circle.selectAll('circle')
            //            .style('fill', function(d) { return (d === this.selected_node) ? d3.rgb(colors(d.id)).brighter().toString() : colors(d.id); })
            // .style('fill', (d) => {
            //     return (d === this.selected_node) ? d3.rgb((d.circleColor || this.circleColor)).brighter(0.4).toString() : (d.circleColor || this.circleColor);
            // })
            .attr('id', (d) => {
                return "circle" + d.id;
            })
            .classed('reflexive', (d) => {
                return d.reflexive;
            });

        this.circle.selectAll("div.text-cnt")
            .style('border-radius', this.squareNodes ? "10%" : "100%")
            .style('background-color', (d) => {
                return (d === this.selected_node || d === this.touchMoveNode || d === this.mouseMoveNode) ? d3.rgb((d.circleColor || this.circleColor)).brighter().toString() : (d.circleColor || this.circleColor);
            })
            .style('background-image', (d) => {
                return d.type === "image" && d.src ? `url(${Q3.s3Url}${d.src}${Q3.browserCapabilities.supports.WebP ? ".webp" : ""})` : "none";
            })
            .style('border-color', (d) => {
                return d3.rgb((d.circleColor || this.circleColor)).darker().toString();
            })
            .style('color', this.circleTextColor)
            .html((d) => {
            return d.type !== "image" ? d.name : ""
        });

        // add new nodes
        let g = this.circle.enter().append('svg:g');

        function onMouseDown(d) {
            if (d3.event.ctrlKey || !d) return;
            if (!this.enabled) return;
            // select node
            this.mousedown_node = d;
            if (this.mousedown_node === this.selected_node) this.selected_node = null;
            else this.selected_node = this.mousedown_node;

            this.setActiveNode(this.mousedown_node.id, Boolean(this.selected_node));

            this.selected_link = null;
            this.removeLinkBtn.addClass('hidden');

            // reposition drag line
            let attr = 'M' + this.mousedown_node.x + ',' + this.mousedown_node.y + 'L' + this.mousedown_node.x + ',' + this.mousedown_node.y
            this.drag_line
                // .style('marker-end', 'url(#end-arrow)')
                .classed('hidden', false)
                .attr('d', attr);

            this.restart();
        }

        function onMouseUp(d) {
            if (!this.mousedown_node && !this.touchMoveNode) return;

            // needed by FF
            this.drag_line
                .classed('hidden', true)
                .style('marker-end', '');

            // check for drag-to-self
            this.mouseup_node = d;
            if (d3.event.type === "touchend" && this.touchMoveNode) {
                this.mouseup_node = this.touchMoveNode;
                this.touchMoveNode = null;
            }
            if (this.mouseup_node === this.mousedown_node) {
                this.resetMouseVars();
                return;
            }

            // unenlarge target node
            d3.select(d3.event.currentTarget).attr('transform', '');

            // add link to graph (update if exists)
            // NB: links are strictly source < target; arrows separately specified by booleans
            let source, target, direction;
            // if (this.mousedown_node.id < this.mouseup_node.id) {
            source = this.mousedown_node;
            target = this.mouseup_node;
            //   direction = 'right';
            // } else {
            //   source = this.mouseup_node;
            //   target = this.mousedown_node;
            //   direction = 'left';
            // }

            let link;
            link = this.links.filter((l) => {
                return (l.source === source && l.target === target || l.source === target && l.target === source);
            })[0];

            if (!link && target && target.id && source && source.id) {
                link = { source: source, target: target };
                this.links.push(link);
                if (this.onCreateLink) {
                    this.onCreateLink();
                }
                Q3.editMode && this.updateSlideQuizLinks();
            }

            // select new link
            // this.selected_link = link;
            this.selected_node = null;
            this.restart();
        }

        g.append('svg:circle')
            .attr('class', 'node')
            .attr('r', (d) => {
                return d.radius*(this.squareNodes ? 1.1 : 1)
            })
            //            .style('fill', function(d) { return (d === this.selected_node) ? d3.rgb(colors(d.id)).brighter().toString() : colors(d.id); })
            // .style('fill', (d) => {
            //     return (d === this.selected_node) ? d3.rgb((d.circleColor || this.circleColor)).brighter().toString() : (d.circleColor || this.circleColor);
            // })
            // .style('stroke', (d) => {
            //     return d3.rgb((d.circleColor || this.circleColor)).darker().toString();
            // })
            .attr('id', (d) => {
                return "circle" + d.id;
            })
            .classed('reflexive', (d) => {
                return d.reflexive;
            })
            .on('mouseover', (d) => {
                if (!this.mousedown_node || d === this.mousedown_node) return;
                // enlarge target node
                this.mouseMoveNode = d;
                $(d3.event.currentTarget).next().find(".text-cnt");
            })
            .on('mouseout', (d) => {
                if (!this.mousedown_node || d === this.mousedown_node) return;
                // unenlarge target node
                // d3.select(d3.event.currentTarget).attr('transform', '');
                $(d3.event.currentTarget).next().find(".text-cnt");
                if (this.mouseMoveNode === d) {
                    this.mouseMoveNode = null;
                }
            })
            .on('mousedown', onMouseDown.bind(this))
            .on('touchstart', onMouseDown.bind(this))
            .on('mouseup', onMouseUp.bind(this))
            .on('touchend', onMouseUp.bind(this));

        // show node IDs
        let foreign = g.append('svg:foreignObject')
            .attr('x', (d) => {
                return d.radius * -1
            })
            .attr('y', (d) => {
                return d.radius * -1
            })
            .attr('width', (d) => {
                return d.radius * 2
            })
            .attr('height', (d) => {
                return d.radius * 2
            })
            .attr('class', 'id');
        foreign.append('xhtml:div')
            .attr('class', 'text-cnt')
            .attr('tabindex', 1)
            .style('border-radius', this.squareNodes ? "10%" : "100%")
            .style('background-color', (d) => {
                return (d === this.selected_node) ? d3.rgb((d.circleColor || this.circleColor)).brighter().toString() : (d.circleColor || this.circleColor);
            })
            .style('background-image', (d) => {
                return d.type === "image" && d.src ? `url(${Q3.s3Url}${d.src}${Q3.browserCapabilities.supports.WebP ? ".webp" : ""})` : "none";
            })
            .style('border-color', (d) => {
                return d3.rgb((d.circleColor || this.circleColor)).darker().toString();
            })
            .style('color', this.circleTextColor)
            .attr('id', (d) => {
                return d.id;
            })
            .append('span')
            .html((d) => {
                return d.type !== "image" ? d.name : ""
            });

        // g.append("svg:title")
        //     .text((d) => {
        //         return d.type !== "image" ? d.name : ""
        //     });

        // remove old nodes
        this.circle.exit().remove();
        // set the graph in motion
        this.force.start();

        if (!Q3.editMode) {
            if (window.MathJax) {
                MathJax.typesetPromise([this.domElement])
            } else {
                awaitMathJax().then(() => {
                    MathJax.typesetPromise([this.domElement])
                })
            }
        }
    }

    createNode(node) {
        let graphNode = {};
        graphNode['id'] = +node.id;
        graphNode['reflexive'] = false;
        graphNode['name'] = node.name;
        graphNode['circleColor'] = node.circleColor;
        graphNode['autoRadius'] = node.autoRadius;
        graphNode['type'] = node.type;
        graphNode['src'] = node.src;
        graphNode['r'] = node.radius;
        graphNode['radius'] = this.calcRadius(graphNode);
        return graphNode;
    }

    addNode(node) {
        this.nodes.push(this.createNode(node));
        this.restart();
    }

    setActiveNode(id = null, bool) {
        let slideQuizNodes = Q3.data.slides[Q3.SlideManager.activeSlide].slideQuiz.nodes;

        slideQuizNodes.forEach((node)=>{
            if(Object.keys(node).includes('active')){
                delete node['active'];
            }

            if (node.id === id && bool) {
                node.active = bool;
            }
        })
        Q3.Events.fire("graphupdated");
        this.restart();
    }

    deleteNodeById(id) {
        let node = this.getNode(id);
        this.deleteNode(node);
        this.restart();
    }

    deleteLinkByKey(link) {
        this.links.splice(this.links.indexOf(link), 1);
        this.selected_link = null;
        this.restart();
        this.updateSlideQuizLinks()
    }


    deleteNodeByKey(node) {
        let slideQuizNodes = Q3.data.slides[Q3.SlideManager.activeSlide].slideQuiz.nodes;
        let index = null;
        for (let i = 0; i < slideQuizNodes.length; i++) {
            if (slideQuizNodes[i].id === node.id) {
                index = i;
                break;
            }
        }
        slideQuizNodes.splice(index, 1);
        this.deleteNode(node);
        Q3.Events.fire("graphupdated");
        this.restart();
    }

    deleteNode(node) {
        this.nodes.splice(this.nodes.indexOf(node), 1);
        this.spliceLinksForNode(node);
        this.selected_node = null;
    }

    changeNodeColor(id, color) {
        let node = this.getNode(id);
        node.circleColor = color;
        $("#" + id).css("background-color", color);
    }

    changeNodeName(id, name) {
        let node = this.getNode(id);
        node.name = name;
        // $("#" + id).text(name).attr("title", name).parent().parent().find("title").text(name);
        clearTimeout(this.nodeNameTimeout);
        this.nodeNameTimeout = setTimeout(() => {
            this.resize();
        }, 500)
    }

    changeNodeRadius(id, radius) {
        let node = this.getNode(id);
        node.r = radius;
        node.autoRadius = false;
        clearTimeout(this.nodeNameTimeout);
        this.nodeNameTimeout = setTimeout(() => {
            this.resize();
        }, 500)
    }

    setNodeAutoRadius(id, value) {
        let node = this.getNode(id);
        node.autoRadius = value;
        clearTimeout(this.nodeNameTimeout);
        this.nodeNameTimeout = setTimeout(() => {
            this.resize();
        }, 500)
    }

    changeNodeType(id, type) {
        let node = this.getNode(id);
        node.type = type;
        this.resize();
    }

    changeNodeSrc(id, src) {
        let node = this.getNode(id);
        node.src = src;
        this.resize();
    }

    createLinks(source, target) {
        let graphPath = {};
        graphPath['source'] = source;
        graphPath['target'] = target;
        // graphPath['left'] = false;
        // graphPath['right'] = true;
        // graphPath['type'] = "edge";
        return graphPath;
    }

    getNode(v) {
        let selectedNode = {};
        d3.selectAll(this.nodes)
            .each((d, i) => {
                if (this.nodes[i].id == v) {
                    selectedNode = this.nodes[i];
                }
            });
        return selectedNode;
    }

    resetMouseVars() {
        this.mousedown_node = null;
        this.mouseup_node = null;
        this.mousedown_link = null;
    }

    destroy() {
        this.isInit = false;
        this.touchMoveNode = {};
        this.nodes = [];
        this.links = [];
        this.enabled = true;
        this.success = false;

        this.resultNodes = [];
        this.resultLinks = [];

        this.lastKeyDown = -1;
        $(this.domElement).empty();
        window.removeEventListener("resize", this.resizeHandler);
        window.removeEventListener('keydown', this.keydownHandler);
    }

    checkResult() {
        let result = [];
        if (this.links.length == this.resultLinks.length) {
            this.links.filter((l) => {
                let resultLink = this.resultLinks.filter((r) => {
                    return ((l.source.id === r.source.id && l.target.id === r.target.id) || (l.source.id === r.target.id && l.target.id === r.source.id));
                });
                if (!!resultLink[0]) {
                    result.push(resultLink[0]);
                }
            });

            if (result.length == this.resultLinks.length) {
                this.enabled = false;
                this.success = true;
                // showSucessMessage();
            }
        }
    }


    findLink(link) {
        return this.links.find((l) => (l.source.id === link.source.id && l.target.id === link.target.id) || (l.source.id === link.target.id && l.target.id === link.source.id));
    }

    getScore() {
        let result = [];
        let wrong = [];
        let score = 0;
        this.links.forEach((l) => {
            let resultLink = [];
            this.resultLinks.forEach((r) => {
                if ((l.source.id === r.source.id && l.target.id === r.target.id) || (l.source.id === r.target.id && l.target.id === r.source.id)) {
                    resultLink = [l];
                    l.type = "correct";
                }
            });
            $("#" + l.source.id).addClass(l.type === "correct" ? "correct" : "wrong");
            $("#" + l.target.id).addClass(l.type === "correct" ? "correct" : "wrong");
            if (!!resultLink[0]) {
                result.push(resultLink[0]);
            } else {
                l.type = "wrong";
                wrong.push(l);
            }
        });
        // this.resultLinks.forEach((r) => {
        //     if (!this.findLink(r)) {
        //         let l = this.createLinks(r.source, r.target);
        //         l.type = "result";
        //         this.links.push(l);
        //     }
        // });
        // $(".text-cnt:not(.correct)").addClass("wrong");
        this.restart();
        this.resize();
        score = result.length - wrong.length;
        // score = result.length;
        this.enabled = false;
        let userInput = this.links.map((link) => {
            return { source: link.source.id, target: link.target.id }
        });
        return { score: score, userInput: userInput };
    }

}


export default Graph;
export { Graph };

const awaitLib = (function () {
    let promise;
    return function () {
        return promise = (promise || new Promise(resolve => {
            console.warn("Q3: D3 not initialized. Begun downloading.");
            injectJS("/js/d3.libs.js").then(function () {
                console.info("Q3: D3 downloaded.");
                resolve();
            });
        }));
    };
})();

const awaitMathJax = (function () {
    let promise;
    return function () {
        return promise = (promise || new Promise(resolve => {
            console.warn("Begun downloading MathJax");
            injectJS("https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js").then(function () {
                console.info("MathJax downloaded.");
                resolve();
            });
        }));
    };
})();
